export default __webpack_public_path__ + "static/Kylie-Wilkinson-450x520-bd975e627ea0f0850f7a8f8cce1759c2.jpg";